// client/src/components/tendermaker/TendermakerHome.js
import React from "react";
import { Link } from "react-router-dom";
import Layout from "../Layout";


const card = {
  border: "1px solid #e5e7eb",
  borderRadius: 14,
  padding: 16,
  background: "white",
};

const btn = {
  display: "inline-block",
  padding: "10px 14px",
  borderRadius: 10,
  border: "1px solid #e5e7eb",
  textDecoration: "none",
  color: "#111827",
  background: "#fafafa",
  fontWeight: 600,
};

export default function TendermakerHome() {
  return (
    <Layout>
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
      <h2 style={{ marginBottom: 6 }}>TenderMaker</h2>
      <div style={{ color: "#6b7280", marginBottom: 16 }}>
        Profile Vault + Bid Workspace + Analyzer + Bid Studio (evidence → page → drafting).
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 14,
        }}
      >
        <div style={card}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>Profile Vault</div>
          <div style={{ color: "#6b7280", marginBottom: 12 }}>
            Upload your company documents (PAN, GST, Udyam, CA certificates, etc.) mapped to a master list.
          </div>
          <Link to="/tendermaker/profile" style={btn}>
            Open Profile Vault
          </Link>
        </div>

        <div style={card}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>Bid Workspace</div>
          <div style={{ color: "#6b7280", marginBottom: 12 }}>
            Create a bid and upload multiple bid-related documents (main PDF + annexures).
          </div>
          <Link to="/tendermaker/bids" style={btn}>
            Open Bid Workspace
          </Link>
        </div>

        <div style={card}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>Bid Analyzer</div>
          <div style={{ color: "#6b7280", marginBottom: 12 }}>
            Run extraction for a bid, dedupe requirements, and see doc-pack planning (vault/auto/manual).
          </div>
          <Link to="/tendermaker/analyzer" style={btn}>
            Open Analyzer
          </Link>
        </div>

        {/* ✅ NEW: Studio shortcut */}
        <div style={card}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>Bid Studio</div>
          <div style={{ color: "#6b7280", marginBottom: 12 }}>
            Open runs, jump evidence to exact PDF pages, draft, sign/stamp, merge PDFs.
          </div>
          <Link to="/tendermaker/bid-studio" style={btn}>
            Open Bid Studio
          </Link>
        </div>
      </div>
    </div>
    </Layout>
  );
}
